export interface UpdateScheduledPuDlProps {
	legIds: number[];
}

export type UpdateScheduledPuDlFormik = Record<string, string | boolean | null> & {
	scheduledPickupDateRange: string | null;
	scheduledDeliveryDateRange: string | null;
	removeScheduledPickup: boolean;
	removeScheduledDelivery: boolean;
};

export const updateScheduledPuDlApiFieldMappings: Record<keyof UpdateScheduledPuDlFormik, string | Record<string, string>> = {
	scheduledPickupDateRange: 'schdPuFrom',
	scheduledDeliveryDateRange: 'schdDelvFrom',
	removeScheduledPickup: 'removeSchdPuDate',
	removeScheduledDelivery: 'removeSchdDelvDate'
};
